/**
 * The bottom limit of percentage.
 */
export const MIN_PERCENT = 0;

/**
 * The upper limit of percentage.
 */
export const MAX_PERCENT = 100;

export const LINE_HEIGHT = 8;
